module.exports = __webpack_public_path__ + "static/media/proyeccion_rendimiento.e2aa2adf.png";